import React from 'react';
import classes from './style.module.scss';
import Cross from '../../media/cross.svg';
import Logo from '../Logo/Logo';

const NavDrawer = ({ onClick, opened }) => {
    return (
        <div className={`${classes.container} ${opened ? classes.opened : ''}`}>
            <div className={classes.header}>
                <Logo />
                <img onClick={onClick} src={Cross} alt="cross" />
            </div>
            <div className={classes.items}>
                <a className={classes.item} href="/">
                    Главная
                </a>
                <a className={classes.item} href="/menu">
                    Меню
                </a>
                <a className={classes.item} href="/news">
                    Новости
                </a>
                {/*<a className={classes.item} href="/shop">*/}
                {/*    Магазин*/}
                {/*</a>*/}
                <a className={classes.item} href="/plan">
                    План зала
                </a>
                <a className={classes.item} href="/contacts">
                    Контакты
                </a>
                <a className={classes.item} href="/promo">
                    Акции
                </a>
                <a className={classes.item} href="/tournaments">
                    Турниры
                </a>
            </div>
            <div className={classes.footer}>
                <a href="tel:+79672775974" className={classes.phoneNumber}>
                    +7-967-277-59-74
                </a>
                <p className={classes.address}>
                    г. Ногинск, ул. Комсомольская, д. 25
                </p>
            </div>
        </div>
    );
};

export default NavDrawer;
